<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <!-- NOTE: The fill property from the path below is hardcoded since this icon is only used for amenities-->
    <!-- and we are currently displaying them using this color -->
    <path
      stroke="transparent"
      fill="#54535b"
      d="M18.875 10.032V8.157H17v-1.25h1.875V5.032h1.25v1.875H22v1.25h-1.875v1.875h-1.25ZM10.166 15.318c0 .13-.07.2-.2.2h-.93c-.13 0-.2-.07-.2-.2V9.923l-.95.4c-.14.054-.23-.005-.23-.155v-.895c0-.11.045-.185.15-.235l1.095-.49a.552.552 0 0 1 .25-.055h.815c.13 0 .2.07.2.2v6.625ZM15.119 11.482a2.04 2.04 0 0 1 1.225 1.9c0 1.27-1.045 2.255-2.46 2.255s-2.465-.985-2.465-2.255c0-.83.45-1.55 1.225-1.905-.465-.31-.73-.8-.73-1.345 0-.964.83-1.77 1.97-1.77 1.14 0 1.97.806 1.97 1.765 0 .555-.265 1.045-.735 1.355Zm-2.36 1.836c0 .645.46 1.095 1.125 1.095.67 0 1.125-.456 1.125-1.095 0-.65-.48-1.16-1.12-1.16-.65 0-1.13.51-1.13 1.16Zm.35-3.056c0 .445.325.806.78.806.45 0 .775-.36.775-.806a.785.785 0 0 0-.785-.794c-.41 0-.77.33-.77.794Z"
    />
    <path
      fill="transparent"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M20.983 12.79a9 9 0 1 1-5.423-9.063"
    />
  </svg>
</template>
